import React, {
  FC,
} from 'react';
import { parseUrlParams } from '../../lib/utils/utils';
import EN from './EN';
import ZH from './ZH';

const WebPointsFAQ: FC = () => {
  const params = parseUrlParams<{ isEnglish: string }>(window.location.href);
  return (
    <>
      {
        params.isEnglish === 'Y' ? (
          <EN />
        ) : (
          <ZH />
        )
      }
    </>
  );
};

export default WebPointsFAQ;
